import { render, staticRenderFns } from "./batch-edit-delivery-date-modal.vue?vue&type=template&id=cf2b6c1a&scoped=true"
import script from "./batch-edit-delivery-date-modal.vue?vue&type=script&lang=js"
export * from "./batch-edit-delivery-date-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2b6c1a",
  null
  
)

export default component.exports